<template>
  <form class="form-horizontal" @submit="submit($event)">
    <section class="card">
      <header class="card-header">
        <div class="card-actions">
          <a href="#" class="card-action card-action-toggle" data-card-toggle></a>
        </div>
        <h2 class="card-title">{{$root.subTitle}}</h2>
      </header>
      <div class="card-body">
        <editor ref="editor" />
      </div>
      <footer class="card-footer text-right">
        <button class="btn btn-primary btn-sm">Submit</button>
        <button class="btn btn-default btn-sm" @click="back($event)">Cancel</button>
      </footer>
    </section>
  </form>
</template>

<script>
import { forms, formsValues } from "resource";
import editor from "./editor";
export default {
  components: { editor },
  data() {
    return {
      id: this.$route.params.id,
      form: {
        layoutId: this.$route.params.layoutId,
        value: null
      }
    };
  },
  mounted() {
    Promise.all([
      forms.get({ id: this.form.layoutId }),
      formsValues.get({ id: this.id })
    ]).then(([a, b]) => {
      this.$refs.editor.layout(a.body.value);
      this.$refs.editor.values(b.body.value);
    });
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      this.form.value = await this.$refs.editor.values();
      formsValues.update({ id: this.id }, this.form).then(a => {
        this.$router.push({
          name: "/forms/values/:layoutId",
          params: { id: this.form.layoutId }
        });
      });
    },
    back(e) {
      e.preventDefault();
      this.$router.go(-1);
    }
  }
};
</script>
